import { render, staticRenderFns } from "./KitchenConfidentialArticle.vue?vue&type=template&id=4415f1fa&"
import script from "./KitchenConfidentialArticle.vue?vue&type=script&lang=js&"
export * from "./KitchenConfidentialArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports